import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { User, BreadcrumbItem, Tracker } from '../../../entities/index';
import { UserService } from '../../../services/user.service';
import { TrackerService } from '../../../services/tracker.service';
import { WHITE_LABEL_BRANDS } from '../../../services/constants.service';
import { TimezoneService } from '../../../services/timezones.service';
import { Api } from '../../../services/api.service';
import QRCode from 'qrcode'

declare var jQuery: any;

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.html'
})
export class UserDetailComponent implements OnInit, OnDestroy {
  subscription: Subscription;

  loadIframe = false;
  backendUrl: string;
  backendLogoutUrl: string;

  userId: number;
  user: User = new User();
  brands: string[] = WHITE_LABEL_BRANDS;
  new_password: { value: string };
  new_tracker: { imei: string, timezone: string, name: string };
  debugPassword: string = null;
  timezones: any[] = [];
  countries: [[string, string]] = null;

  pageTitle = 'User Detail';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('User List', 'user', '/user'),
    new BreadcrumbItem('User Detail', 'user')
  ];

  constructor(protected api: Api,
              protected router: Router,
              protected route: ActivatedRoute,
              protected userService: UserService,
              protected trackerService: TrackerService,
              protected notification: NotificationsService,
              protected timezoneService: TimezoneService) {
    this.userId = Number(route.snapshot.params.id);
    this.pageTitle += ' #' + this.userId;
    this.breadcrumbs[1].title = this.pageTitle;
    this.new_password = {value: null};
    this.clearNewTrackerForm();
    this.timezones = this.timezoneService.getAllTimezones();
  }

  @Log()
  ngOnInit() {
    this.subscription = Observable.forkJoin(
      this.userService.getCountries(),
      this.userService.get(this.userId)
    ).subscribe((results: [any, User]) => {
      this.countries = results[0];
      this.user = results[1];
    });
  }

  @Log()
  ngOnDestroy(): any {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  clearNewTrackerForm() {
    this.new_tracker = {
      imei: null,
      timezone: null,
      name: null
    };
  }

  @Log('blue')
  save() {
    this.userService
      .save(this.user)
      .subscribe(user => {
        this.user = user;
        this.notification.success('SUCCESS', 'The user has been updated.');
      });
  }

  @Log('blue')
  openPasswordModal() {
    jQuery('.new-password').modal();
  }

  @Log('blue')
  saveNewPassword() {
    jQuery('.new-password').modal('hide');
    this.userService
      .updatePassword(this.user, this.new_password.value)
      .subscribe(user => {
        this.user = user;
        this.notification.success('SUCCESS', 'The password has been updated.');
      });
    this.new_password.value = '';
  }

  @Log('blue')
  generateDebugPassword() {
    this.debugPassword = null;
    this.userService
      .createDebugPassword(this.user)
      .subscribe((password) => {
        this.debugPassword = password;
        var canvas = document.getElementById('qrcode')
        QRCode.toCanvas(canvas,`weenect://login?username=${this.user.mail}&password=${password}`)
      });
    jQuery('.debug-password').modal();

  }

  @Log('blue')
  removeAllTrackers() {
    if (confirm("Are you sure you want to remove this user's trackers ? This is definitive.")) {
      this.userService.removeTrackers(this.user).subscribe(
        () => {
          this.notification.success('SUCCESS', "This user's trackers have been removed");
        }
      );
    }
  }
  @Log('blue')
  removeUser() {
    if (confirm('Are you sure you want to remove this user ? This is definitive')) {
      this.userService.remove(this.user).subscribe(
        () => {
          this.router.navigate(['/user']);
          this.notification.success('SUCCESS', 'The user has been removed.');
        }
      );
    }
  }

  @Log('blue')
  openRegisterTrackerModal() {
    this.clearNewTrackerForm();
    jQuery('.register-tracker').modal();
  }

  @Log('blue')
  registerTracker() {
    this.trackerService.registerTracker(this.user, this.new_tracker).subscribe(
      (tracker: Tracker) => {
        jQuery('.register-tracker').modal('hide');
        this.router.navigate(['/tracker', tracker.id]);
        this.notification.success('SUCCESS', 'The tracker has been registered.');
      }
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/user/user-detail.component.ts